module.exports = __webpack_public_path__ + "static/media/SLP.b85c338f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SLP.png
// module id = 1287
// module chunks = 0